export const styles = {
  global: {
    // Fixes ChakraUI overflow issue https://github.com/chakra-ui/chakra-ui/issues/2966
    ".chakra-collapse:not([style*='display: none'])": {
      overflow: "initial !important",
    },
  },
};
